import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as itemsActions from 'store/modules/items';

import * as util from 'store/modules/utils';

import ItemDetailArmmor from 'components/items/ItemDetailArmmor';

class ItemDetailArmmorContainer extends Component {

  componentDidMount() {
    
  }

  popupClose = () => {
    const {ItemsActions} = this.props;

    const isView = 'none';
    const itemSeq = '';
    ItemsActions.ctrlItemDtlPopup({isView, itemSeq});
  }

  ctrlDefendUp = (e) => {
    const {ItemsActions} = this.props;
    ItemsActions.ctrlWeaponUp(e.target.value);
  }

  ctrlArmmorUp = (e) => {
    const {ItemsActions, currSelArmmor} = this.props;
    const {optionView} = currSelArmmor.currItemOption;
    const currSel = 'currSelArmmor';
    const gubun = optionView === e.target.value ? '' : e.target.value;
    ItemsActions.setItemDetailOption({currSel, gubun});
  }

  setBodyup = (cnt) => {
    const {ItemsActions} = this.props;
    const currSel = 'currSelArmmor';
    ItemsActions.setBodyup({currSel, cnt});
  }

  setPowerup = (cnt) => {
    const {ItemsActions} = this.props;
    const currSel = 'currSelArmmor';
    ItemsActions.setPowerup({currSel, cnt});
  }

  setPrefixUp = (cnt) => {
    const {ItemsActions} = this.props;
    const currSel = 'currSelArmmor';
    ItemsActions.setPrefixUp({currSel, cnt});
  }

  render() {
    const {popupClose, ctrlArmmorUp, setBodyup, setPowerup, setPrefixUp} = this;
    const {currSelArmmor} = this.props;
    const plusUpGrid = util.calcPlusUpGrid();
    
    return (
      <ItemDetailArmmor popupClose={popupClose}
      plusUpGrid={plusUpGrid}
      currSelArmmor={currSelArmmor}
      ctrlArmmorUp={ctrlArmmorUp}
      setBodyup={setBodyup}
      setPowerup={setPowerup}
      setPrefixUp={setPrefixUp}
      />
    );
  }
}

export default connect(
  (state) => ({
    currSelArmmor: state.items.toJS().currSelArmmor
  }),
  (dispatch) => ({
    ItemsActions: bindActionCreators(itemsActions, dispatch)
  })
)(ItemDetailArmmorContainer);